import React from "react";
import FirstNews from "../../../assets/partnersBackground.jpg";

const newsData: any = [
	{
		id: 1,
		title: "The Tech Revolution in Logistics: A Glimpse into the Future",
		description:
			"Commitment to protecting what you hold dear is a testament to the transformative power of insurance.",
		content: "Full content of the news article goes here...",
		image: FirstNews,
	},
	{
		id: "2",
		title: "Another News Title",
		description: "Description for another news item.",
		image: FirstNews,
	},
	{
		id: "3",
		title: "Yet Another News Title",
		description: "Description for yet another news item.",
		image: FirstNews,
	},
];

const NewsDiv: React.FC = () => {
	return (
		<div>
			{/* <div className={classes.sixthComponent}> */}
			{/* <div className={classes.sixthComponentSlider}>
					<div className={classes.sixthContainerTitle}>
						<p className={classes.newsTitle}>Lajme & artikuj</p>
						<Link to="" className={classes.forUsButton}>
							LEXO <span className="text-xl">&#8250;</span>
						</Link>
					</div>
					<div className={classes.newsMainContainer}>
						{newsData.map((newsItem: any) => (
							<div
								key={newsItem.id}
								className={classes.newsContainer}
							>
								<Image preview={false} src={newsItem.image} />
								<p className={classes.guide}>Guide</p>
								<p className={classes.newsContainerDescription}>
									{newsItem.title}
								</p>
								<p
									className={
										classes.newsContainerSecondDescription
									}
								>
									{newsItem.description}
								</p>
								<Link
									to={`/${newsItem.title
										.replace(/\s+/g, "-")
										.toLowerCase()}`}
									state={{
										id: newsItem.id,
										title: newsItem.title,
									}}
								>
									READ MORE{" "}
									<span className="text-xl">&#8250;</span>
								</Link>
							</div>
						))}
					</div>
				</div> */}
			{/* </div> */}
		</div>
	);
};

export default NewsDiv;
